// extracted by mini-css-extract-plugin
module.exports = {"container":"LoginStyle_container__vWkn9","form":"LoginStyle_form__2w2hh","Link":"LoginStyle_Link__1sDeL","span":"LoginStyle_span__3mAgB","p":"LoginStyle_p__3cfMG"};